<template>
  <div>
    <v-dialog v-model="documentDialog" max-width="450px" lazy>
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <v-layout align-center justify-end row fill-height>
            <div class="headline font-weight-bold mx-auto">
              Documentos da Usina
            </div>
          </v-layout>
        </v-card-title>
        <v-card-text v-if="loading" class="ma-0 pa-0">
          <p class="py-2 text-md-center">
            Carregando
            <v-progress-circular
              color="purple"
              indeterminate
              size="16"
              class="mr-2"
            ></v-progress-circular>
          </p>
        </v-card-text>
        <v-card-text v-else class="ma-0 pa-0">
          <v-list v-if="documents?.length > 0" class="ma-0 pa-0">
            <v-list-tile v-for="photo in documents" :key="photo.name">
              <v-list-tile-content>
                <v-list-tile-title>
                  <a
                    :href="photo.url"
                    target="_blank"
                    style="color: #000"
                    class="doc"
                    >{{ photo.name }}</a
                  >
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action> </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <p v-else class="py-2 text-md-center">
            A Usina não possui documentos
          </p>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              color="primary"
              text
              @click="pickIdDoc"
              :disabled="loadingUpload"
            >
              <v-progress-circular
                v-if="loadingUpload"
                indeterminate
                color="white"
                size="18"
                class="mr-2"
              ></v-progress-circular
              ><v-icon v-else class="mr-2">mdi-upload</v-icon> Adicionar
              documento</v-btn
            >
            <input
              type="file"
              ref="idDoc"
              multiple
              style="display: none"
              accept="application/pdf,image/*"
              @change="pickedPhotos($event)"
            />
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import { uploadDocument } from "../../services/powerplants";
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      powerplant_id: null,
      idDoc: [
        {
          name: "",
          data: null,
        },
      ],
      documentDialog: false,
      color: "",
      snackMessage: "",
      snackbar: false,
      loadingUpload: false,
      loading: false,
    };
  },
  computed: {
    ...mapState("configuration", ["documents"]),
    ...mapState(["user"]),
  },
  methods: {
    ...mapActions("configuration", ["getDocuments"]),
    async showDocumentModal(id) {
      this.loading = true;
      this.documentDialog = true;
      this.powerplant_id = id;
      await this.getDocuments(this.powerplant_id);
      this.documentDialog = true;
      this.loading = false;
    },
    pickIdDoc() {
      this.$refs.idDoc.click();
    },
    async pickedPhotos(event) {
      this.loadingUpload = true;
      const photosFiles = event.target.files;
      for (const photo of photosFiles) {
        if (photo !== undefined) {
          if (!this.idDoc[0].name) {
            this.idDoc = [];
          }
          this.idDoc.push({
            name: photo.name,
            data: photo,
          });
        }
      }
      try {
        await uploadDocument({
          id: this.powerplant_id,
          data: this.idDoc,
          agent_email: this.user?.email,
        });
        this.loading = true;
        await this.getDocuments(this.powerplant_id);
        this.loading = false;
        this.snack("Arquivo anexado com sucesso.", "green");
      } catch {
        this.snack("Erro ao anexar arquivo, tente novamente!", "red");
      }
      this.loadingUpload = false;
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped lang="scss">
.doc {
  transition: 0.4s;
  &:hover {
    opacity: 0.8 !important;
  }
}
</style>
